import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FuseSharedModule } from '@fuse/shared.module';

const routes = [
  {
      path        : 'finanzas',
      loadChildren: './finanzas/finanzas.module#FinanzasModule'
  },
  {
    path        : 'categorias',
    loadChildren: './categories-expenses/categories-expenses.module#CategoriesExpensesModule'
  },
  {
    path        : 'registros',
    loadChildren: './tracking-spend/tracking-spend.module#TrackingSpendModule'
  }
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes),
    FuseSharedModule
  ]
})
export class GastosModule { }
